<template>
  <div id="footer" class="ui inverted vertical footer segment">
    <div class="ui left aligned container">
      <div class="ui stackable inverted divided grid">
        <div class="five wide column">
          <h4 class="ui inverted header">Kontakti</h4>
          <div class="ui inverted link list">
            <a href="#" class="item">SIA BIOveikals, Reg/PVN nr.: LV40103164759, jur. adrese: Ziedlapas, Daugmales
              pag., Ķekavas nov.</a>
            <a href="tel:37120010800" class="item">Tel.: +371 200 108 00</a>
            <a href="mailto:info@bioveikals.com" class="item">E-pasts: pasutit@bioveikals.com</a>
          </div>
        </div>
        <div class="five wide column">
          <h4 class="ui inverted header">Sociālie tīkli</h4>
          <div class="ui inverted link list">
            <a href="https://www.facebook.com/memorywater" taget="_blank" class="item"><i
                class="facebook square icon"></i> Facebook</a>
            <a href="https://twitter.com/MemoryWater" target="_blank" class="item"><i class="twitter square icon"></i>
              Twitter</a>
          </div>
        </div>
        <div class="six wide column">
          <h4 class="ui inverted header">Noderīga informācija</h4>
          <div class="ui inverted link list">
            <a href="https://api.memorywater.lv/files/ligums.pdf" target="_blank" class="item">Līguma noteikumi</a>
            <a href="https://www.memorywater.com/lv/sakums#where-to-buy189" target="_blank" class="item">Kur nopirkt</a>
            <a @click="showDeliveryZones" class="item">Piegādes reģionu karte</a>
            <!-- delivery address zones -->
            <div class="ui modal" id="delivery-zone3">
              <i class="close icon"></i>
              <div class="image content">
                <div class="ui  image">
                  <img src="https://api.memorywater.lv/img/documents/piegades-teritorija.png">
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div class="ui inverted section divider"></div>
      <img src="/static/img/bv_logo_black_small.png" class="ui left image" style="height: 100px;" />
      <div class="ui horizontal inverted small divided link list">
        <p class="item" href="#">© BIOveikals, 2024. Visas tiesības aizsargātas.</p>
      </div>
	  <img src="/static/img/eu_logo.png" class="ui left image" style="height: 100px;" />
      <div class="ui horizontal inverted small divided link list">
        <p class="item" href="#">LIAA Nr.9.2-17-L-2025/668</p>
        <p class="item" style="display:block; padding-left: 0; font-size: 0.8em; max-width: 400px; line-height: 1.5em; text-align: justify;" href="#">
		<b>Atbalstāmā darbība:</b>
		komercdarbības procesu uzlabošana, resursu pārvaldības jomā – specializēts risinājums uzņēmuma kurjera web-aplikācija pasūtījumu pārvaldībai.<br />
		<b>Risinājums:</b>
		web aplikācija.<br />
		Projekts ir saņēmis finansiālu atbalstu no <b>ES atveseļošanas fonda.</b>
		</p>
      </div>
	  <!--div class="ui horizontal inverted small divided link list">
        <p class="item" href="#">LIAA līguma numurs: 19.02.24. Nr.17.2-5-L-2024/124</p>
        <p class="item" style="display:block; padding-left: 0; font-size: 0.8em; max-width: 400px; line-height: 1.5em; text-align: justify;" href="#">"B10veikals" 2024. gada 21. februārī noslēdza līgumu par atbalsta saņemšanu Nr. 17.2-5-L-2024/124 atbalsta saņemšanai uzņēmuma digitalizācijas programmā “Latvijas Atveseļošanas un noturības mehānisma plāna 2. komponentes “Digitālā transformācija” 2.2. reformu un investīciju virziena “Uzņēmumu digitālā transformācija un inovācijas” 2.2.1.r. “Uzņēmējdarbības digitālās transformācijas pilna cikla atbalsta izveide ar reģionālo tvērumu” 2.2.1.2.i.  investīcijas “Atbalsts procesu digitalizācijai komercdarbībā”. Noliktavas darba optimizācijai mūsu uzņemums, SIA B10veikals, ieviesa digitālās transformācijas risinājumu - skenēšanas web-aplikāciju telefonā, ar kuras palīdzību automatizēja un digitalizēja noliktavas preču apriti, lai ir iespējams savākt tikai tās preces, kas pasūtītas, katrai precei skenējot svītru kodu.</p>
      </div-->
	  <div class="ui inverted small divided link list">
        <a href="https://www.kurpirkt.lv/" title="Interneta veikalu cenas - Kurpirkt.lv">
          <img style="filter: grayscale(100%);Border:none;" alt="Interneta veikalu cenas - Kurpirkt.lv" src="//www.kurpirkt.lv/media/kurpirkt88.gif" width="88" height="31" />
	    </a>
        <a href="https://www.salidzini.lv/">
          <img alt="salidzini.lv" title="Labākās cenas interneta veikalos" style="filter: grayscale(100%); border:none;" src="https://static.salidzini.lv/images/logo_button.gif" width="88" height="31" />
        </a>
	  </div>
    </div>
  </div>
</template>

<script>

  export default {
    methods: {

      showDeliveryZones() {

        $('#delivery-zone3')
          .modal('show')
          ;

      }
    }
  }
</script>


// WEBPACK FOOTER //
// Footer.vue?7f16284a